import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { DASHBOARD } from "helpers/viewContent";
import { getDashboard_ } from "store/services/dashboardService";
import { useModules } from "helpers/modules";
import * as actions from "store/actions/index.js";

// countUp
import CountUp from "react-countup";
import GraphPage from "./GraphPage";

const Dashboard = ({ dispatch, user, userProfile }) => {
  let userRole = user?.user ? user?.user : userProfile;

  const [modules, setModules] = useState(useModules);
  const [dbmodules, setDbModules] = useState([]);
  const [dashboardList, SetDashboardList] = useState({});

  // Current Year
  const currentYear = new Date().getFullYear();

  // Year Filter
  const [yearFilter, setYearFilter] = useState({
    year: currentYear,
  });

  // Dashboard API
  async function getDashboardList_() {
    try {
      dispatch(actions.persist_store({ loader: true }));

      let payload = {
        year: yearFilter.year?.toString(),
      };

      let res = await dispatch(getDashboard_(payload));

      dispatch(actions.persist_store({ loader: false }));

      SetDashboardList(res?.body);
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  }

  // Call API on year change
  useEffect(() => {
    getDashboardList_();
  }, [yearFilter]);

  // User Permissions
  useEffect(() => {
    let userPermission =
      userProfile?.user_permissions?.length > 0
        ? userProfile?.user_permissions
        : [];

    let userData =
      user?.user?.user_permissions?.length > 0
        ? user?.user?.user_permissions
        : userPermission;

    let newArr = [];

    for (let val of userData) {
      let moduleName = val.module_name
        ? JSON.parse(val.module_name)
        : "";

      newArr.push(moduleName?.value);
    }

    setDbModules(newArr);
  }, []);

  // Year List
  const years = [];

  for (let i = currentYear; i >= 2010; i--) {
    years.push(i);
  }

  return (
    <>
      <Helmet title={DASHBOARD.CURRENT_MODULE} />

      <div className="page-header d-flex justify-content-between align-items-center flex-wrap">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-home"></i>
          </span>{" "}
          Dashboard
        </h3>

        {/* Year Filter */}
       
      </div>

      <div className="row">
        {modules?.length > 0 &&
          modules.map((mod, i) => {
            if (dashboardList.hasOwnProperty(mod.model_name)) {
              const value = dashboardList[mod.model_name];
              mod.count = value;
            }

            dbmodules.filter((val) => {
              if (val === mod.model_name) {
                mod.is_permission = false;
              }
            });

            if (
              mod.is_dashboard &&
              !mod.is_permission &&
              userRole?.role === "3"
            ) {
              return (
                <div className="col-md-4 my-2 px-3" key={i}>
                  <div
                    className={`card ${mod.dashboard_color} card-img-holder h-100 text-white mb-3`}
                  >
                    <Link className="dashboard_tags" to={mod.url}>
                      <div className="card-body">
                        <img
                          src="../../assets/images/dashboard/circle.svg"
                          className="card-img-absolute"
                          alt="circle-image"
                        />

                        <h4 className="font-weight-normal">
                          {mod.name}
                          <i className="mdi mdi-chart-line mdi-24px float-right"></i>
                        </h4>

                        <h2>
                          <CountUp
                            start={0}
                            end={mod.count ? mod?.count : 0}
                            duration={3}
                          />
                        </h2>
                      </div>
                    </Link>
                  </div>
                </div>
              );
            } else if (
              mod.is_dashboard &&
              mod.is_permission &&
              userRole?.role === "0"
            ) {
              return (
                <div className="col-md-4 my-2 px-3" key={i}>
                  <div
                    className={`card ${mod.dashboard_color} card-img-holder text-white mb-3`}
                  >
                    <Link className="dashboard_tags" to={mod.url}>
                      <div className="card-body">
                        <img
                          src="../../assets/images/dashboard/circle.svg"
                          className="card-img-absolute"
                          alt="circle-image"
                        />

                        <h4 className="font-weight-normal">
                          {mod.name}
                          <i className="mdi mdi-chart-line mdi-24px float-right"></i>
                        </h4>

                        <h2>
                          <CountUp
                            start={0}
                            end={mod.count ? mod?.count : 0}
                            duration={3}
                          />
                        </h2>
                      </div>
                    </Link>
                  </div>
                </div>
              );
            }

            return null;
          })}
      </div>
 <div className="my-2">
          <label className="me-2 fw-bold ">Year</label>

          <select
            className="form-select"
            value={yearFilter.year}
            onChange={(e) =>
              setYearFilter({
                year: e.target.value,
              })
            }
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      <GraphPage
        dashboardList={dashboardList}
        yearFilter={yearFilter}
      />
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    user: state.Auth,
    userProfile: state?.persistStore?.userProfile,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(Dashboard);